import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './WatchButton';
import { getWatchCount } from '../../../publicSession/selectors';

export type StateProps = Pick<Props, 'watchCount'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  watchCount: getWatchCount(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
